import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import * as Urls from 'src/constants/EndpointUrls';
import { Pulldown } from 'jbc-front/components/icons';
import { openNewTab, redirectTo } from 'src/utils/Http';
import styles from './ExtraActionsSection.scss';
import { withTranslation } from 'react-i18next';

const AllowanceDeductionsMethod = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    render() {
      const { downloadTemplateCsvPageUrl, confirmed, currentBonus } = this.props;

      return (
        <div className={styles.baloonWrap}>
          <div className={styles.baloon}>
            <ul className={styles.links}>
              <li>
                <a
                  disabled={!confirmed}
                  className={!confirmed ? styles.disabled : null}
                  onClick={() =>
                    redirectTo(`${Urls.SHOW_ALLOWANCE_DEDUCTIONS_BONUS}?client_bonus_id=${currentBonus.value}`)
                  }
                  role="presentation"
                >
                  <Pulldown size={8} />
                  {this.props.t('features.EmployeeBonus.components.AllowanceDeductionMethod.Provision_and_deduction_list')}
                </a>
              </li>
              <li>
                <a
                  onClick={() => openNewTab(downloadTemplateCsvPageUrl)}
                  className={currentBonus === undefined || confirmed ? styles.disabled : undefined}
                  role="presentation"
                >
                  <Pulldown size={8} />
                  {this.props.t('features.EmployeeBonus.components.AllowanceDeductionMethod.Provision_and_deduction_items_CSV_import')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      );
    }
  }
);

export default withTranslation('translation')(AllowanceDeductionsMethod);
